import React, { useState, createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState('');

    useEffect(() => {
        validateIam().then(async user => {
            if (!user) {
                setUser(null);
                setAuthenticated(false);
                return;
            }

            setUser({
                id: user.id,
                username: user.username,
                email: user.email,
                name: user.name,
                module: user.module || 'OCMT'
            });
            setAuthenticated(true);
            setLoading(false);

            const allowedScreens = await ExecuteAxios.api('get', '/profile-screens/get-profile-screens-ids-by-profile/');

            if (allowedScreens.length > 0) {
                const priorityIds = [2, 3, 4, 5, 6, 7, 8, 9, 1];

                const targetScreen = priorityIds
                    .map(id => allowedScreens.find(screen => screen.id === id))
                    .find(screen => screen !== undefined);

                if (targetScreen?.path && allowedScreens.length > 0) {
                    navigate(targetScreen.path);
                }
            }
        });
    }, []);

    async function validateIam() {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: '/api/authenticator/iam',
                withCredentials: true
            };
            const authenticatedData = await axios.request(config);

            if (authenticatedData && authenticatedData.data && authenticatedData.data.email) {
                const parameters = {
                    email: authenticatedData.data.email.replace(/\s/g, "")
                }
                return await ExecuteAxios.api('get', `/user/get-user-by-email`, { params: parameters })
            } else return null;
        } catch (error) {
            setLoading(false);
        }
    }

    const login = async (email, password) => {
        try {
            let data = JSON.stringify({
                email: email,
                password: password
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: '/api/authenticator/login',
                data: data,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            await axios.request(config);
            const user = await validateIam();

            if (user) {
                const allowedScreens = await ExecuteAxios.api('get', '/profile-screens/get-profile-screens-ids-by-profile/');

                setUser({
                    id: user.id,
                    username: user.username,
                    email: user.email,
                    name: user.name,
                    module: user.module || 'OCMT'
                });
                setAuthenticated(true);

                if (allowedScreens.length > 0) {
                    const priorityIds = [2, 3, 4, 5, 6, 7, 8, 9, 1];

                    const targetScreen = priorityIds
                        .map(id => allowedScreens.find(screen => screen.id === id))
                        .find(screen => screen !== undefined);

                    if (targetScreen?.path && allowedScreens.length > 0) {
                        navigate(targetScreen.path);
                    }
                }

                setTimeout(async () => {
                    const clientPlan = await ExecuteAxios.api('get', '/client/check-plan-of-client/');
                    if (clientPlan) {
                        alert(clientPlan)
                    }
                }, 5000);
            } else {
                setUser(null);
                setAuthenticated(false);
            }
        } catch (error) {
            setUser(null);
            setAuthenticated(false);
        }
    };

    const logout = async () => {
        localStorage.removeItem("allowedScreens");
        await axios.post('/api/authenticator/logout');
        setUser(null);
        setAuthenticated(false);
        navigate("/");
    };

    return (
        <AuthContext.Provider
            value={{ authenticated, user, loading, login, logout }}>
            {children}
        </AuthContext.Provider >
    );

};